module.exports = __webpack_public_path__ + "media/images/lb/841-a4dd817323efa92eec29256953817805.svg";